export default "__VITE_ASSET__0sT69lXY__"